<template>
  <div class="user">
    <div v-if="loggedIn">
      <label>Hej, {{ user.username }}</label
      ><leech-logo :color="hasUserLogo"></leech-logo>
    </div>
    <div v-else @click="goToLogin">
      <label>Log in her</label><leech-logo :color="noUser"></leech-logo>
    </div>
  </div>
</template>

<script>
import { LeechLogo } from "@/components";
import router from "../router";

export default {
  components: {
    LeechLogo,
  },
  data() {
    return {
      user: this.$store.getters["auth/getUser"],
    };
  },
  computed: {
    loggedIn() {
      return !(!this.user || !this.user.username);
    },
    hasUserLogo() {
      return this.user.hexColor;
    },
    noUser() {
      return "#d05366";
    },
  },
  methods: {
    goToLogin() {
      router.push("/bruger/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.user {
  height: 50px;
  cursor: pointer;
  display: flex;
  justify-content: right;

  div {
    display: flex;
    align-items: center;

    label {
      font-size: 16px !important;
      font-style: italic;
      margin-right: 15px;
      color: #666666;
    }

    img {
      width: 50px;
      height: 50px;
    }
  }
}

@media only screen and (max-width: 600px) {
  .user {
    div {
      label {
        display: none;
      }
    }
  }
}
</style>
